<template>
  <div style="height: 100%">
    <SplitContainer21 ref="refSplitContainer21" style="height:100%" :layout="12">
      <template #top>
        <TableMain name="one table" ref="QTHITable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" :table_height_adjust="-6"
          :show_toolbar_button="[0, 0, 0, 0, 1]" :hb_table_class="'hb_table_qthiable_class1'"
          :only_text="$t('common.show_all')" @only_methods="only_methods" @tool_invoke="tool_invoke"
          @current_changed="current_changed" tableref="aa11c4b4d2f942ecb22caccc3ff10b40">
          <template #query>
            <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions()">
            </el-date-picker>
            <el-select class="ml-1" v-model="QuotationType" placeholder="报价类型" size="small" style="width: 100px"
              clearable>
              <el-option label="大货报价" value="大货报价"></el-option>
              <el-option label="打样报价" value="打样报价"></el-option>
            </el-select>
            <el-input placeholder="报价申请编号" class="ml-1" clearable size="small" style="width: 180px"
              v-model="QuotationTaskNum"></el-input>
            <el-input placeholder="客户名称" class="ml-1" clearable size="small" style="width: 180px"
              v-model="CustName"></el-input>
          </template>

          <template #toolbar>
            <el-popover placement="right" title="提示" width="350" trigger="hover" style="border-color: red;">
              <p>默认红色规则：</p>
              <p>1、物料未完善；</p>
              <p>2、物料已完善的前提下，是否接受外协为“否”的未创建询价申请;</p>
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
        </TableMain>
      </template>

      <template #bottom>
        <TableMain ref="QTHITable2" :fields="detail_fields" :show_query_container="false" :title="table_title.title2"
          :date_picker_label="date_picker_label" :table_height_adjust="10" :show_pagination="true" :show_filter="false"
          :pager_count="5" :isBusy="isBusy2" :loading_width="45" :hb_table_class="'hb_table_qthiable_class2'"
          :show_close="true" :show_close_cancel="true" :show_toolbar_button="[0, 0, 0, 0, 0]"
          @state_change="state_change" @on_input="detail_on_input" @on_cell_button_click="on_cell_button_click" tableref="918b1bcb431541c5b95bc27cff719eee">
          <template #operation>
            <!-- <el-button type="primary" @click="createConsultApply"><i class="iconfont icon-save"></i>
              &nbsp;&nbsp;创建询价申请
            </el-button> -->
            <QueryButton :type="'primary'" :iconClass="'iconfont icon-save'" :size="'mini'"
              @on_query="createConsultApply" label="创建询价申请" class="ml-2"></QueryButton>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer21>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'ConsultQuote'" @setAccessory="setAccessory">
      </FileUpload>
    </el-dialog>
    <!-- 发送邮件 -->
    <el-dialog title="邮件通知" :visible.sync="emailVisible" width="80%" :top="'8vh'" :close-on-click-modal="false">
      <el-form ref="dataForm" label-width="60px" class="demo-dataForm" style="height: 650px">
        <el-col :span="24">
          <el-form-item label="主题">
            <el-input type="textarea" v-model="email_subject" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容">
            <div name="div_email_content" style="overflow:auto;height: 600px;border:1px solid #DCDFE6">
              <el-input type="textarea" ref="div_email_content" v-html="email_content" clearable></el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendToEmail" type="primary" plain><i class="iconfont icon-email"
            style="font-size: 12px"></i>&nbsp;发送邮件</el-button>
        <el-popover placement="right" title="提示" width="200" trigger="hover" content="点击“发送邮件”后内容已复制到剪切板，可直接粘贴使用！"
          style="border-color: red;">
          <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
        </el-popover>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as QuotationTaskHandleController from "../../controllers/sd/QuotationTaskHandleController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import FileUpload from "../FileUpload.vue"
import QueryButton from "../components/base/QueryButton"
import SplitContainer21 from "../components/container/SplitContainer21"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer21,
    TableMain,
    QueryButton,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -3), new Date()],
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
        title2: "quote_apply_detail",
      },
      fields: _.cloneDeep(QuotationTaskController.fields.default),
      detail_fields: _.cloneDeep(QuotationTaskHandleController.fields.detail_invent),
      QuotationType: "",
      QuotationTaskNum: "",//报价申请编号
      CustName: "",//客户名称
      isBusy: false,
      isBusy2: false,
      current_accessory: null, ///当前派单选中附件
      accessoryVisible: false,
      all_role_users: [],
      PurchUser_Options: [],///采购员
      emailVisible: false,
      email_subject: "",
      email_content: ""
    }
  },
  async created() {
    this.fields = _.filter(this.fields, (t) => {
      return t.key != "fcCheckSQOApproved" && t.key != "SQOApprover" && t.key != "is_send_email" && t.key !== "fcCheckSQOHasClosed"
    })
    let _field = _.find(this.fields, {
      key: "id",
    })
    delete _field["type"]
    await this.getAllRoleUsers()
    this.PurchUser_Options = this.all_role_users.filter((t) => t.role_code == 'SYS-QBuyer').map((t) => {
      return { value: t.username, label: t.username }
    })

    let _field1 = _.find(this.detail_fields, { key: "PurchUser" })
    _field1["multiple"] = true
    _field1["_options"] = {
      provider: (v) => {
        return this.PurchUser_Options
      },
    }
    console.log(_field1)
  },
  mounted() {

  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 报价申请相关操作
    only_methods(only_value) {
      this.on_query(this.$refs.QTHITable1.SetData, false)
    },
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let hasDate = true
      let p = { is_deleted: { "=": 0 } }

      if (this.QuotationTaskNum != "") {
        p.QuotationTaskNum = { like: "%" + this.QuotationTaskNum + "%" }
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = { like: "%" + this.CustName + "%" }
        hasDate = false
      }
      if (this.QuotationType != "") {
        p.quotationType = { "=": this.QuotationType }
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p["create_at"] = { ">=": this.$date.format(this.date_range[0], "yyyy-MM-dd"), "<": _toDate }
      }
      let _result = await QuotationTaskController.methods.getData(p, "quotation_handle_invent")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_result[0], { fcCheckSQOApproved: true, fcCheckSQOIsAllClosed: false })
        _.each(dt, (t) => {
          t._error = !t.fcCheckSQOInventIsOK || !t.fcCheckSQOAllApplyIsCreated
        })
        if (!this.$refs.QTHITable1.only_value)
          dt = _.filter(dt, (t) => {
            if (!t.fcCheckSQOInventIsOK || !t.fcCheckSQOAllApplyIsCreated)
              return t
          })
        set_data(_.orderBy(dt, ["id"], ["desc"]))
      }
      this.isBusy = false
    },

    ///打印导出
    tool_invoke(data, cb) {
      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },

    async current_changed(old, current) {
      this.$refs.QTHITable2.SetData([])
      if (current) {
        await this.Detail_Query(current.id)
      }
    },
    //#endregion

    //#region 报价明细相关
    ///查询报价明细
    async Detail_Query(QTId, isLoading = true) {
      if (isLoading) {
        this.isBusy2 = true
      }
      let p = { is_deleted: { "=": 0 }, closed: { "<>": 2 } }
      p.QuotationTaskId = { "=": QTId }
      let _result = await QuotationTaskController.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_result[0], (t) => {
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
          if (t.Manufacturer != "")
            t.Manufacturer = t.Manufacturer.split(",")
          if (t.ItemId == null || t.ItemId == "") {
            t.update_by_username = ""
            t.update_at = ""
          }
          if (t.PurchUser && t.PurchUser != "") {
            t.PurchUser = t.PurchUser.split(";")
          }
          return t
        })
        this.$refs.QTHITable2.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
      }
      this.isBusy2 = false
    },

    ///明细行输入事件
    async detail_on_input(data) {

      if (data.field.key == "ItemId") {
        data.item.NameAlias = ""
        let _result = await InventTableController.methods.getItemData({ ItemId: data.item.ItemId, is_deleted_ax: "0", })
        if (!_.isNull(_result) && _result && _result.length > 0 && _result[0].length > 0) {
          let table1_current = this.$refs.QTHITable1.GetCurrentItem()
          _.each(_result[0], (m) => {
            if (m.dataAreaId == table1_current.dataAreaId || m.dataAreaId == "002")
              data.item.NameAlias = m.NameAlias
          })
        }
      }
    },

    ///保存明细
    async Detail_SaveData(cb, data) {
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = data ? data : this.$refs.QTHITable2.GetSelectedItems()
      if (detail_data.length == 0) {
        this.msgToasts("请勾选要保存的数据！", "info")
        cb(null)
        return
      }

      let require_fileds = _.map(_.filter(this.detail_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        p.edit.push({
          id: m.id, ItemId: m.ItemId, NameAlias: m.NameAlias, Accessory: m.Accessory,
          UnfoldSize: m.UnfoldSize,
          PurchUser: _.join(m.PurchUser, ";"),
          InventHandleBy: this.$global.global_data.local_username,
          InventHandleAt: this.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss")
        })
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        if (!data) {
          await this.Detail_Query(this.$refs.QTHITable1.GetCurrentItem().id, false)
          this.msgToasts(this.$t("notify.action_successfully"), "success")
        }
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///创建询价申请
    async createConsultApply(cb) {
      let selected_items = _.cloneDeep(this.$refs.QTHITable2.GetSelectedItems())
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(null)
        return
      }

      let msg = "", has_apply_items = []
      _.each(selected_items, (t) => {
        if (msg == "") {
          if (t.InventHandleBy === null) msg = t.ItemId + " 号物料未确认，请先保存后再创建询价申请！"
          else if (t.IsHomemade == 0) msg = t.ItemId + "该物料不接受外协，不能创建询价申请！"
          else if (t.PurchUser == null || (t.PurchUser && t.PurchUser.length == 0)) msg = t.ItemId + "该物料采购员为空！"
          if (t.fcCheckSQOConsultApplayIsCreated) has_apply_items.push(t.ItemId)
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      let ask = await this.$confirm(this.$t("notify.is_continue") + "(注：默认询价申请为启用状态，如果需要进一步处理请到询价申请进行处理！)").then(t => { return true }).catch(t => { return false })
      if (!ask) {
        cb(null)
        return
      }

      if (has_apply_items.length > 0) {
        ask = await this.$confirm(_.join(has_apply_items, ",") + " 物料的询价申请已存在，是否继续？").then(t => { return true }).catch(t => { return false })
        if (!ask) {
          cb(null)
          return
        }
      }
      await this.Detail_SaveData(cb, selected_items)
      let p = this.getConsultData(selected_items)
      let rt = await ConsultQuoteConttroller.methods.saveDataDetailApply(p)
      if (rt) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        if (rt.add && rt.add.length > 0) {
          _.each(selected_items, (t) => {
            t.fcCheckSQOConsultApplayIsCreated = true
          })
          await this.SendEmail(rt.add)
        }
      }
      else
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      cb(null)
    },
    getConsultData(selected_items) {
      let qt_cur = this.$refs.QTHITable1.GetCurrentItem()
      let p = { add: [], edit: [] }, lineCount = 1
      _.each(selected_items, (t) => {
        let m = _.cloneDeep(t), dp = {}
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        let consult_detail_fields = _.cloneDeep(ConsultQuoteConttroller.fields.application)
        _.each(consult_detail_fields, (ck) => {
          if (m[ck.key] && !ck._not_to_api)
            dp[ck.key] = m[ck.key]
        })
        dp.LineNum = lineCount++
        dp.FromBatchQty = m.FromBatchQty
        dp.BatchQty = m.BatchQty
        dp.QuotationTaskNum = qt_cur.QuotationTaskNum
        dp.CustAccount = qt_cur.CustAccount
        dp.CustName = qt_cur.CustName
        dp.DeliveryAddress = m.DeliveryAddress
        dp.DeliveryMode = m.DeliveryMode
        dp.Accessory = m.Accessory
        dp.dataAreaId = qt_cur.dataAreaId
        dp.QuotationTaskDetailId = m.id
        dp.quotationType = qt_cur.quotationType
        dp.is_valid = true
        p.add.push(dp)
      })
      return p
    },
    sendToEmail() {
      const range = window.getSelection().getRangeAt(0)
      const h1 = document.getElementsByName('div_email_content')
      range.setStart(h1[0], 0)
      range.setEnd(h1[0], 1)
      document.execCommand("Copy")
      window.open('mailto:?content-type=text/html&subject=' + this.email_subject + '&body=', "_blank")
      window.getSelection().removeAllRanges()
    },
    ///发送报价申请处理邮件
    async SendEmail(data) {
      let selected_items = this.$refs.QTHITable2.GetSelectedItems()
      data.forEach((t) => {
        let m = selected_items.find((m) => t.QuotationTaskDetailId == m.id)
        if (m) t.PurchUser = m.PurchUser
      })
      let dt = []
      this.PurchUser_Options.forEach((t) => {
        let _data = data.filter((m) => m.PurchUser.findIndex((a) => a == t.value) > -1)
        if (_data && _data.length > 0)
          dt.push({ username: t.value, data: _data })
      })
      for (var k in dt) {
        let p = _.map(dt[k].data, (t) => { return { ConsultQuoteApplyNum: t.ConsultQuoteApplyNum } })
        p = _.uniqWith(p, _.isEqual)
        let em = await commonController.handleEmailNotify(p, "consult_order", this, this.all_role_users, "email_get_consult_data", [dt[k].username])
        if (em) {
          this.email_subject = em.subject
          this.email_content = em.content
        }
      }
    },
    //#endregion
    //#region 附件
    async on_cell_button_click(data) {
      if (!data.item.ItemId || data.item.ItemId == "") {
        this.msgToasts("请先完善物料编号!", "info")
        return
      }
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.ItemId)
    },
    async dialogClosed() {
      if (this.current_accessory && this.current_accessory.Accessory) {
        let m = { id: this.current_accessory.id, Accessory: this.current_accessory.Accessory }, ml = []
        if (m.id && m.id != "") ml.push(m)
        this.current_accessory.AccessoryCount = JSON.parse(this.current_accessory.Accessory).length
        await QuotationTaskController.methods.saveDetailData({ edit: ml, isUpdateAccessory: true })
      }
    },
    async setAccessory(data) {
      this.current_accessory.Accessory = data
      await this.dialogClosed()
    },
    //#endregion
    ///关闭报价申请
    async state_change(data) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      if (data.state == "closed") { ///关闭
        if (_.findIndex(data.selected_items, (t) => t.closed == 1 || t.closed == 2) > -1) {
          this.msgToasts("已关闭或发送关闭申请，不能重复执行该操作！", "info")
          return
        }
        let v = await this.msgModal(this.$t("notify.is_continue"))
        if (v) {
          let confirm_m = await this.$prompt('请输入关闭原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\S\s]+$/,
            inputErrorMessage: '请输入原因',
            inputValue: ""
          }).then(({ value }) => {
            return { state: true, val: value }
          }).catch(() => {
            return { state: false }
          })
          if (confirm_m && confirm_m.state) { }
          else return

          let dt = _.map(data.selected_items, (t) => {
            return {
              QuotationTaskDetailId: t.id,
              Description: confirm_m.val
            }
          })
          let _result = await QuotationTaskController.methods.addQuoteCloseApplication(dt)
          if (!_.isNull(_result) && _result && _result.length > 0) {
            //关闭时给报价申请发送关闭申请邮件
            let _dt = _.map(_.cloneDeep(data.selected_items), (t) => {
              t.CloseDescription = confirm_m.val
              t.CloseUserName = this.$global.global_data.local_username
              t.CloseDate = this.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss")
              switch (t.IsHomemade) {
                case 0: t.IsHomemade = '否'; break
                case 1: t.IsHomemade = '是'; break
                case 2: t.IsHomemade = '纯外协'; break
              }
              return t
            })
            let email_data = _.groupBy(_dt, "create_by_username")
            await commonController.handleEmailData(email_data, "quote_order_closed", this)
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
          else
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      }
      else if (data.state == "cancel_closed") { ///撤销关闭
        let wait_close_data = _.filter(data.selected_items, (t) => t.closed == 1)
        if (wait_close_data.length == 0) {
          this.msgToasts("暂无待关闭数据！", "info")
          return
        }
        //检查是否已经关闭
        let closed_data = await QuotationTaskController.methods.getDetailData(_.map(data.selected_items, (t) => { return { id: { "=": t.id }, closed: { "=": 2 } } }))
        if (!_.isNull(closed_data) && closed_data && closed_data.length > 0 && closed_data[0].length > 0) {
          this.msgToasts("报价已被销售关闭，请重新查询再执行该操作！", "info")
          return
        }
        let v = await this.msgModal(this.$t("notify.is_continue"))
        if (v) {
          let _result = await QuotationTaskController.methods.cancelQuoteCloseApplication(_.map(data.selected_items, (t) => { return { QuotationTaskDetailId: t.id } }))
          if (!_.isNull(_result) && _result && _result.length > 0) {
            let current = this.$refs.QTHITable1.GetCurrentItem()
            await this.Detail_Query(current.id)
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
          else
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      }
    }
  },
}
</script>

<style>
.hb_table_qthiable_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 115rem;
}

.hb_table_qthiable_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>
